import { action } from "../common/Action"
import { OperatoriClient, UserDataDto, UserDto } from "../generated";

const service = new OperatoriClient();

class OperatorsActions {
    @action
    async getOperatoriByEsercente() {
        return (await service.getOperatoriByEsercente())!;
    };

    @action
    async update(id: number, operatore: UserDataDto) {
        await service.update(operatore, id);
        return { ...operatore, codOperatore: id } as UserDto;
    };

    @action
    async add(operatore: UserDataDto) {
        await service.add(operatore)
        this.getOperatoriByEsercente();
    };
}
export default new OperatorsActions();